import { serialize, parse } from 'cookie';
import { v4 as uuidv4 } from 'uuid';
import { EXPIRATION_TIME_IN_MILLISECONDS } from './constants';

export function createRcxCookie(): string {
	const uuid = uuidv4();
	const expirationTime = EXPIRATION_TIME_IN_MILLISECONDS;
	const date = new Date();
	date.setTime(date.getTime() + expirationTime);

	const rcxCookie = serialize('rcx', uuid, {
		domain: window.location.hostname,
		path: '/',
		maxAge: expirationTime,
		expires: date,
		secure: true,
	});

	return rcxCookie;
}

export function getRcxCookieValue(documentCookie: string): string {
	const { rcx } = parse(documentCookie);

	if (typeof rcx === 'undefined') {
		const rcxCookie = createRcxCookie();
		document.cookie = rcxCookie;
		const { rcx: parsedRcx } = parse(rcxCookie);
		return parsedRcx;
	}

	return rcx;
}

export function getNativeRcxCookie(): string {
	return getRcxCookieValue(document.cookie);
}
